import {
  CommentService,
  OptionService,
  PostService,
  TermService,
  TokenService,
  UserService,
  ChannelService,
  AlertService,
  ActionService,
  TriggerinfoService,
  TriggerService,
  ReportService,
  MonthReportService,
  DataExportService,
  LoginfoService,
  AuthcodemanService,
  AbnormalService,
  OrganizeService,
  PermissionsService,
  OrgpermissionService,
  DeviceService,
  EquipmentService,
  Expirechannels
} from '../services'

export default Vue => {
  // alias
  const services = {
    comment: CommentService,
    option: OptionService,
    post: PostService,
    term: TermService,
    token: TokenService,
    user: UserService,
    channel: ChannelService,
    alert: AlertService,
    action: ActionService,
    triggerinfo: TriggerinfoService,
    trigger: TriggerService,
    report: ReportService,
    monthreport: MonthReportService,
    dataexport: DataExportService,
    loginfo: LoginfoService,
    authcodeman: AuthcodemanService,
    abnormal: AbnormalService,
    organizes: OrganizeService,
    permissions: PermissionsService,
    orgpermissions: OrgpermissionService,
    device: DeviceService,
    equipment: EquipmentService,
    expirechannels: Expirechannels
  }

  // mount the services to Vue
  Object.defineProperties(Vue, {
    services: { get: () => services }
  })

  // mount the services to Vue component instance
  Object.defineProperties(Vue.prototype, {
    $services: { get: () => services }
  })
}



// WEBPACK FOOTER //
// ./src/libraries/plugins/services.js